/**
 * AngularJS registration for the icon service.
 *
 * The class and its helpers moved to `./icons` so Node-side callers can use
 * them without the Angular module and jQuery (issue #1071). This file keeps
 * the `gpCommon.service` wiring — and re-exports the module — so existing
 * importers of this path are unaffected, and the registration still runs
 * exactly once on load.
 *
 * Import `./icons` directly if you need IconService WITHOUT Angular;
 * importing this path pulls in `../app`.
 */

import { gpCommon } from '../app';
import { IconService } from './icons';

export * from './icons';

gpCommon.service(IconService.serviceName, IconService);
